import React from 'react';
import BaseFilterDropdown from './baseFilterDropdown';

const OrderTagsDropdown = ({
  includedTags,
  excludedTags,
  clearAllFilters,
  resetFilterCheck,
  status,
  setSelectedTags,
  setFilterIncludedTags,
  filterIncludedTags,
  matchOptionFlag,
  setMatchOptionFlag,
}) => {
  return (
    <BaseFilterDropdown
      title="Tags"
      persistentMenuKey="orderTagsDropdown"
      includedItems={includedTags}
      excludedItems={excludedTags}
      clearAllFilters={clearAllFilters}
      resetFilterCheck={resetFilterCheck}
      status={status}
      setSelectedItems={setSelectedTags}
      setFilterIncludedItems={setFilterIncludedTags}
      filterIncludedItems={filterIncludedTags}
      matchOptionFlag={matchOptionFlag}
      setMatchOptionFlag={setMatchOptionFlag}
      showMatchOption={true}
      showAddInput={false}
      maxVisibleItems={4}
      testIdPrefix="tag"
    />
  );
};

export default OrderTagsDropdown;
